<router-outlet></router-outlet>
 <button *ngIf="isDev" (click)="loadAppUser()">update app user</button> 
